import { render, staticRenderFns } from "./LandingSurveyRedirect.vue?vue&type=template&id=4a167208&"
import script from "./LandingSurveyRedirect.vue?vue&type=script&lang=js&"
export * from "./LandingSurveyRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports